import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import useCurrentPage from '../../../hooks/useCurrentPage';
import styles from './StockIcons.scss';

const propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  href: PropTypes.string,
  align: PropTypes.string,
  target: PropTypes.string,
};

const defaultProps = {
  icon: 'icon icon-dollie-handcarts',
  className: '',
  color: '',
  href: '',
  align: 'text-center',
  target: '',
};

const StockIcons = ({ href, color, icon, className, align, target }) => {
  const classes = cx(icon, className);
  const { primaryColor, secondaryColor, tertiaryColor } = useCurrentPage();

  const iconColor = (() => {
    switch (color) {
      case 'primary':
        return primaryColor;
      case 'secondary':
        return secondaryColor;
      case 'tertiary':
        return tertiaryColor;
      default:
        return color || secondaryColor;
    }
  })();

  const iconSpan = (
    <span
      className={`${classes}`}
      style={{ color: iconColor }}
    />
  );

  return (
    <div className={`${styles.link} ${align} ${styles.iconFont}`}>
      {href
        ? (
          <a href={href} target={target} rel="noopener noreferrer">
            {iconSpan}
          </a>
        )
        : iconSpan
      }
    </div>
  );
};

StockIcons.propTypes = propTypes;
StockIcons.defaultProps = defaultProps;

export default StockIcons;
